import { BaseExportModal } from './ExportModal'
import { DEALS_PIPELINE_COLUMNS } from 'components/DataExpansionComponents/Deals/dealsPipelineColumnInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startDealsPipelineReportExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

interface PipelineExportModalProps {
  show: boolean
  handleClose: () => void
  filters: Record<string, unknown>
  selectedIds?: number[]
  excludeIds?: number[]
}

export default function PipelineExportModal(props: PipelineExportModalProps) {
  const pipelineColumnHelper = createExportColumnHelper({
    columns: DEALS_PIPELINE_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Company Information',
      elements: [
        pipelineColumnHelper.retrieveColumn('company_name'),
        pipelineColumnHelper.retrieveColumn('category'),
        pipelineColumnHelper.retrieveColumn('type'),
        pipelineColumnHelper.retrieveColumn('taro'),
        pipelineColumnHelper.retrieveColumn('taro_closed'),
        pipelineColumnHelper.retrieveColumn('domain'),
      ],
    },
    {
      title: 'Activity',
      elements: [
        pipelineColumnHelper.retrieveColumn('last_modified'),
        pipelineColumnHelper.retrieveColumn('days_since_last_modified'),
      ],
    },
    {
      title: 'Account Details',
      elements: [
        pipelineColumnHelper.retrieveColumn('sales_stages'),
        pipelineColumnHelper.retrieveColumn('account_owner'),
        pipelineColumnHelper.retrieveColumn('tag'),
        pipelineColumnHelper.retrieveColumn('count'),
        pipelineColumnHelper.retrieveColumn('closed'),
      ],
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Deals Pipeline...' }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startDealsPipelineReportExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Deals Pipeline',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Pipeline Download"
      subTitle="Download up to 10,000 pipeline at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Download Pipeline"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props.handleClose}
    />
  )
}
